'use client';

import { notFound } from 'next/navigation';
import Popup from '@/features/popup';
import { extractHomeComponents } from '@/app/(home-page)/_utils/extract-home-components';
import { useHomePageData } from '@/app/(home-page)/_utils/use-home-page-data';
interface Props {
  slug?: string;
  isLandingCategory?: boolean;
}
function HomeContent({
  slug,
  isLandingCategory = false
}: Props) {
  const {
    data: homeProperties,
    isLoading
  } = useHomePageData(slug);
  const extractedComponents = extractHomeComponents(homeProperties?.components, slug);
  if (!isLoading && !homeProperties) notFound();
  if (!extractedComponents) return null;
  const isLandingPage = !!slug;
  const showH1 = isLandingPage && !isLandingCategory;
  return <>
            {!isLandingPage && <Popup isHomePage />}
            {showH1 && <h1 className='hidden'>{homeProperties?.title}</h1>}
            <div className='relative z-10 flex w-full flex-col gap-6 pb-10 pt-4 lg:gap-8 lg:pb-12 lg:pt-10'>
                {extractedComponents?.map(item => item)}
            </div>
        </>;
}
export default HomeContent;